import React from "react";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust";
import RouteAnalysis from "./routeAnalysis";

const RouteAnalysisPage = () => {
  return (
    <NavHeightAdjust>
      <RouteAnalysis />
    </NavHeightAdjust>
  );
};

export default RouteAnalysisPage;
